import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import {
  Heading,
  Text,
  Divider,
  List,
  ListItem,
  Link as ChakraLink,
} from "@chakra-ui/react";

import Image from 'next/image'

import { configFile } from "@/config";
import { formatTitleId } from "@/helpers/formatTitleId";
import Link from "next/link";

export const MarkdownRender = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      children={children || ""}
      rehypePlugins={[rehypeRaw, rehypeSanitize]}
      components={{
        h1: ({ node, ...props }) => (
          <Heading
            fontSize="4xl"
            fontWeight="800"
            mt="20px"
            mb="30px"
            as="h1"
            {...props}
          ></Heading>
        ),
        h2: ({ node, ...props }) => (
          <Heading
            fontSize="3xl"
            fontWeight="700"
            mt="20px"
            mb="30px"
            as="h2"
            id={formatTitleId(node.children)}
            {...props}
          ></Heading>
        ),
        h3: ({ node, ...props }) => (
          <Heading
            fontSize="2xl"
            fontWeight="700"
            mt="10px"
            mb="20px"
            as="h3"
            {...props}
          ></Heading>
        ),
        h4: ({ node, ...props }) => (
          <Heading
            fontSize="xl"
            fontWeight="700"
            mt="5px"
            mb="10px"
            as="h4"
            {...props}
          ></Heading>
        ),
        h5: ({ node, ...props }) => (
          <Heading
            fontSize="lg"
            fontWeight="700"
            mt="2px"
            mb="50px"
            as="h5"
            {...props}
          ></Heading>
        ),
        h6: ({ node, ...props }) => (
          <Heading
            fontSize="lg"
            fontWeight="700"
            mt="2px"
            mb="5px"
            as="h6"
            {...props}
          ></Heading>
        ),
        p: ({ node, ...props }) => (
          <Text
            fontSize="18px"
            fontWeight="400"
            mb="20px"
            as="p"
            {...props}
          ></Text>
        ),
        hr: ({ node, ...props }) => <Divider mb="20px" mt="10px" {...props} />,
        img: ({ node, ...props }) => (
          //@ts-ignore
          <Image quality={75} placeholder="blur" sizes="(max-width: 768px) 90vw, 768px" blurDataURL={'/images/logo_banner.png'} width={500} height={500} style={{ objectFit: 'cover', width: '100%', borderRadius: '6px' }}
            {...props}
          />
        ),
        ul: ({ node, ...props }) => (
          <
            List ml="25px" mt="10px" listStyleType="disc" {...props} />
        ),
        ol: ({ node, ...props }) => (
          <List
            ml="25px"
            mt="10px"
            as="ol"
            listStyleType="decimal"
            {...props}
          />
        ),
        li: ({ node, ...props }) => <ListItem mb="5px" {...props} />,
        a: ({ node, ...props }) => (
          <ChakraLink prefetch={false} as={Link} color={configFile.primaryAccentColor} {...props} />
        ),
      }}
    />
  );
};